/**
 * components/MockModeBanner.jsx
 * ──────────────────────────────────────────────────────────────────
 * Phase M6.0 (May 9, 2026) — yellow strip across the top of the app
 * shell that's visible iff the most recent backend response carried
 * `_mock: true`. Prevents the M5 "data is not coming" confusion
 * where mock-mode synthetic counts looked identical to real ingest.
 */
import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { getMockMode, subscribeMockMode } from '../services/mockModeBus';

export default function MockModeBanner() {
  const [active, setActive] = useState(getMockMode());
  useEffect(() => subscribeMockMode(setActive), []);
  if (!active) return null;
  return (
    <div
      className="w-full bg-amber-300 text-amber-900 text-xs font-medium px-3 py-1.5 flex items-center justify-center gap-2 border-b border-amber-400"
      data-testid="mock-mode-banner"
      role="status"
    >
      <AlertTriangle size={14} />
      <span>
        <b>Preview / Mock Mode</b> — responses are synthetic. Set <code className="font-mono">ENABLE_MOCK_ROUTES=false</code> for real device calls.
      </span>
    </div>
  );
}
